export default __webpack_public_path__ + "static/media/029-x ray.9cc675aa.svg";